// extracted by mini-css-extract-plugin
export default {"table":"LiveSupport_table__biGNq","header":"LiveSupport_header__MfV2B","row":"LiveSupport_row__0jUN-","unread_row":"LiveSupport_unread_row__bbR3Y"};